import { RevealOnScroll } from "@/components/site/Reveal";
import { Shield, Wrench, Clock, PhoneCall } from "lucide-react";

const CARDS = [
  { icon: Shield, title: "12-Month Powertrain", body: "Every vehicle we sell is covered for engine, transmission and drivetrain for a full year from date of delivery." },
  { icon: Wrench, title: "Complimentary First Service", body: "Your first scheduled service is on us — inspection, fluids, filters and a full electronic diagnostic." },
  { icon: Clock, title: "Extended Options", body: "Extend to 24 or 36 months with our extended coverage plans. Ask us for a plan tailored to your usage." },
  { icon: PhoneCall, title: "One Number, Always", body: "One dedicated line for warranty claims and support — no call trees, no scripts, just a human." },
];

export default function Warranty() {
  return (
    <div data-testid="warranty-page" className="pt-40 pb-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mb-16 max-w-3xl">
          <div className="overline mb-6">Warranty</div>
          <RevealOnScroll
            element="h1"
            className="h-editorial text-[clamp(3rem,7vw,6rem)]"
            lines={["Peace of mind,", "as <em>standard</em>."]}
          />
          <p className="mt-8 text-white/70 text-lg font-light leading-relaxed">
            A Maklan Motors vehicle isn't just a car — it's a commitment.
            Here is exactly what that commitment includes.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {CARDS.map((c, i) => (
            <div key={c.title} data-testid={`warranty-card-${i}`} className="border border-white/10 p-10 hover:border-[#C5A059]/50 transition-all duration-500">
              <c.icon size={22} className="text-[#C5A059]" />
              <h3 className="font-display text-2xl mt-5">{c.title}</h3>
              <p className="text-white/60 mt-3 leading-relaxed">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
